import { render, staticRenderFns } from "./Webmail.vue?vue&type=template&id=d172fbca&"
import script from "./Webmail.vue?vue&type=script&lang=js&"
export * from "./Webmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Webmail.vue"
export default component.exports